import { PrimaryLinkArrow } from '../../../styles';
import {
  adjustInsuranceProductLinksWithFlags,
  adjustInvestmentProductLinksWithFlags,
} from '../../../utils/adjustProductLinksWithFlags';
import {
  bankingLinks,
  insuranceLinks,
  investmentLinks,
  primaryLink,
  promoCard,
} from '../../data/productConstants';
import { MobileMenuPromoCard } from '../components/MobileMenuPromoCard';
import {
  LinksColumnTitle,
  LinksContainer,
  LinksSubContainer,
  MobileMenuPrimaryLink,
  NavLink,
  SectionSubTitle,
  SectionTitle,
  TitleContainer,
} from '../mobileMenu.style';

export const ProductMobileMenu = ({
  insuranceNavUpdates,
  investmentNavUpdates,
}: {
  insuranceNavUpdates?: boolean;
  investmentNavUpdates?: boolean;
}) => {
  const updatedInvestmentLinks = adjustInvestmentProductLinksWithFlags({
    investmentNavUpdates,
    productLinks: investmentLinks,
  });
  const updatedInsuranceLinks = adjustInsuranceProductLinksWithFlags({
    insuranceNavUpdates,
    productLinks: insuranceLinks,
  });

  return (
    <>
      <TitleContainer>
        <SectionTitle>Products & Services</SectionTitle>
        <SectionSubTitle>
          See what products our advisors can help with
        </SectionSubTitle>
        <MobileMenuPrimaryLink href={primaryLink.href}>
          {primaryLink.text}
          <PrimaryLinkArrow />
        </MobileMenuPrimaryLink>
      </TitleContainer>
      <LinksContainer>
        <LinksSubContainer>
          <LinksColumnTitle>{bankingLinks.title}</LinksColumnTitle>
          {bankingLinks.links.map((bankingLink) => (
            <NavLink key={bankingLink.text} href={bankingLink.href}>
              {bankingLink.text}
            </NavLink>
          ))}
        </LinksSubContainer>
        <LinksSubContainer>
          <LinksColumnTitle>{updatedInvestmentLinks.title}</LinksColumnTitle>
          {updatedInvestmentLinks.links.map((investmentLink) => (
            <NavLink key={investmentLink.text} href={investmentLink.href}>
              {investmentLink.text}
            </NavLink>
          ))}
        </LinksSubContainer>
        <LinksSubContainer>
          <LinksColumnTitle>{updatedInsuranceLinks.title}</LinksColumnTitle>
          {updatedInsuranceLinks.links.map((insuranceLink) => (
            <NavLink key={insuranceLink.text} href={insuranceLink.href}>
              {insuranceLink.text}
            </NavLink>
          ))}
        </LinksSubContainer>
        <MobileMenuPromoCard promoCard={promoCard} />
      </LinksContainer>
    </>
  );
};
